module.exports = __webpack_public_path__ + "5c114213/img/menu-icon.5f8facae.svg";